declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let pixelInitialized = false

export function initMetaPixel() {
  if (pixelInitialized) return
  pixelInitialized = true

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  document.head.appendChild(t)

  window.fbq('init', '1677362759916769')
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Guía Anti-Sofocos Nocturnos en 7 Días',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
